import 'core-js/stable';
import VideoRecorderConfig from './interface/videoRecorderConfig';
import RecorderEventMap from './interface/RecorderEventMap';
import {DetectRTCUtility} from './utils/DetectRTCUtility'
import { VideoRecorderBase } from './videoRecorderBase';
import { CustomEventOnInit } from './types/customtypes';

export  default class VideoRecorder extends VideoRecorderBase{

    
         //@ts-ignore
        constructor(config?: VideoRecorderConfig|undefined|null) {
            super(config);

        }
        /**
         * @returns {Promise<void>} promise
         */
        public  init =  (): Promise<CustomEventOnInit|unknown> =>{
            return  this.__init__();

        }

        public  getRecorder =  ()=>{
            return this.recorder;

        }

         /**
         * @returns {Promise<void>} promise
         */
        public  StartRecording =  ()=>{
            return  this.__startRecording__();
        }

         /**
         * @returns {Promise<void>} promise
         */
        public  StopRecording  =  ()=> {
            return this.__stopRecording__();
        }
         /**
         * @param {string} filename
         * @returns {Promise<{status:number;data:any;message?undefined}|{status:number;data:{};message:string;}>} result from backend saving video result
         */

        public  SaveVideo  =  (filename:string)=> {
            return  this.__manualSave__(filename);
       }

        /**
         * @param {E} event
         * @param {RecorderEventMap[E]} callback
         * @returns {Promise<void>} promise
         */
        public  async off<E extends keyof RecorderEventMap>(event: E) {
            await  this.__off__(event);
        }

        /**
         * @param {E} event
         * @param {RecorderEventMap[E]} callback
         * @returns {Promise<void>} promise
         */
        public async  on<E extends keyof RecorderEventMap>(event: E, callback: RecorderEventMap[E]): Promise<void>{
            await this.__on__(event, callback);
        }

        /**
         * @returns {string} unique filename for video recorder with .web exstention
         */
        public generateUniqueFileName =(): string=>{
            return  this.__generateUniqueFileName__();
        }
       /**
         * @returns {boolean} Check if the browser is compatible with ResumableJs
         */
        public IsResumableSupported =():boolean =>{
            return this.__IsResumableSupported__();
        }
        
        public Retry = ()=>{
            this. __Retry__();
        }

        public DeInit = ()=>{
            return this.__deInit__();
        }

}


declare global {
    interface Window { Abintegro: any; }
}
window.Abintegro = {};
window.Abintegro.SDK = {};
window.Abintegro.SDK.DetectRTCUtility = DetectRTCUtility;
window.Abintegro.SDK.VideoRecorder =  VideoRecorder;
